(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-before-after"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll("[data-ba]").forEach(section => {

    const afterImg = section.querySelector(".ba-img-after");
    const handle = section.querySelector("[data-handle]");
    const box = section.querySelector(".ba-box");

    let dragging = false;

    const update = (clientX) => {
      const rect = box.getBoundingClientRect();
      let x = clientX - rect.left;

      x = Math.max(0, Math.min(x, rect.width));
      const percent = (x / rect.width) * 100;

      /* LEFT = BEFORE | RIGHT = AFTER */
      afterImg.style.clipPath = `inset(0 0 0 ${percent}%)`;
      handle.style.left = percent + "%";
    };

    const start = (e) => {
      dragging = true;
      update(e.clientX);
      document.addEventListener("pointermove", move);
      document.addEventListener("pointerup", stop);
    };

    const move = (e) => {
      if (!dragging) return;
      update(e.clientX);
    };

    const stop = () => {
      dragging = false;
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", stop);
    };

    handle.addEventListener("pointerdown", start);
    box.addEventListener("pointerdown", start);

  });

});
  } catch(e) { console.error(e); }
})();

})();
